import { en, es, fr } from "./translations";

const translations = {
  en: en,
  es: es,
  fr: fr,
};

export default translations;
